'use client';

import { PrizeByTeam, PrizeInfo } from '../types';
import PrizeItem from '../prize/PrizeItem';
import TitleH2 from '../common/TitleH2';
import { useState } from 'react';
import { EdfTeams } from '@/lib/directus';

interface Props {
  data: PrizeByTeam;
  teamsDetails: Array<EdfTeams>;
  teamDefault: string;
}

const hasCompetitionEnoughData = (prizeInfos: Array<PrizeInfo>): boolean => {
  if (!prizeInfos || prizeInfos.length === 0) {
    return false;
  }

  for (let i = 0; i < prizeInfos.length; i++) {
    if (!prizeInfos[i].rank || prizeInfos[i].rank === '0') {
      return false;
    }
  }

  return true;
};

export default function Prizes({ data, teamsDetails, teamDefault }: Props) {
  const teamNames = teamsDetails.map((team) => team.name || '');
  const [teamComboParams, setTeamComboParams] = useState<{
    teamName: string;
  }>({
    teamName: teamDefault,
  });

  const handleSelectTeamChanged = (teamName: string) => {
    setTeamComboParams((prevState) => {
      return { ...prevState, teamName };
    });
  };

  const competitionTitleOrders = data[teamComboParams.teamName]
    ? data[teamComboParams.teamName].competitionTitleOrders
    : {};

  return (
    <div className="lg:bg-horizontal-gradient-block-bar mb-10 bg-stone-50 px-2 pb-16 pt-5 bg-bar-hero-horizontal-gradient lg:mb-20 lg:px-10">
      <div>
        {teamNames.length > 1 && (
          <select
            className="select select-bordered w-full max-w-xs rounded-[100px] border-zinc-200 text-sm font-bold focus:outline-none"
            value={teamComboParams.teamName}
            onChange={(e) => handleSelectTeamChanged(e.target.value)}
          >
            {teamNames.map((teamName, index) => {
              return (
                <option key={index} value={teamName}>
                  {teamName}
                </option>
              );
            })}
          </select>
        )}
      </div>
      <div className="">
        {Object.entries(competitionTitleOrders)
          .sort((a, b) => {
            return b[1] - a[1];
          })
          .map((entry) => entry[0])
          .map((competitionTitle, index) => {
            const teamCompetitionPrizes =
              data[teamComboParams.teamName].prizeInfosByTitle[competitionTitle];

            // const hasEnoughData = hasCompetitionEnoughData(teamCompetitionPrizes);

            // if (!hasEnoughData) {
            //   return <div key={index}></div>;
            // }

            return (
              <div
                key={`team_${index}`}
                className={`relative flex w-full flex-col flex-nowrap gap-0.5 ${teamNames.length > 1 ? 'mt-6' : ''}`}
              >
                <TitleH2 color="black" size="medium" customFont={true} styles="my-5">
                  {competitionTitle}
                </TitleH2>
                {teamCompetitionPrizes
                  .filter((data) => !!data.rank && data.rank !== '0')
                  .map((prizeInfo, index2) => (
                    <PrizeItem key={`prizes_${index2}`} data={prizeInfo}></PrizeItem>
                  ))}
              </div>
            );
          })}
      </div>
    </div>
  );
}
